<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('CargoMsg.Cargo_CreateBillsPayable')"
    width="1200px"
    :close-on-click-modal="false"
    :destroy-on-close="true"
    class="main-content warehouse-dialog"
  >
    <div class="tabs-container">
      <tab-bill-payment-jc ref="bpPage" page-source="financeAp" :application-status="9" />
    </div>
    <hr>
    <div style="margin-bottom: 10px; display: flex">
      <div style="padding-right: 75%">
        <el-button type="primary" @click="mergeGeneratePay">{{ $t('CargoMsg.Cargo_MergeGeneratePay') }}</el-button>
      </div>
      <div>
        <el-button type="primary" @click="generatePay">{{ $t('CargoMsg.Cargo_GeneratePay') }}</el-button>
        <el-button @click="innerVisible=false">{{ $t('Pricing.Cancel') }}</el-button>
      </div>
    </div>
    <!--    创建详情-->
    <payable-detail-dialog
      v-if="detailDialog.visible"
      :visible.sync="detailDialog.visible"
      :action="detailDialog.action"
      :merge-type="detailDialog.mergeType"
      :uuids="detailDialog.uuids"
      :title="detailDialog.title"
      @saveResult="saveHandler"
    />
  </el-dialog>
</template>

<script>
import TabBillPaymentJc from '@/views/cargo/v0/Clearing/components/BillPayment/tabBillPaymentJc'
import PayableDetailDialog from '@/views/cargo/v0/Clearing/components/SharedCenter/payableDetailDialog'

export default {
  name: 'PayableDialog',
  components: { PayableDetailDialog, TabBillPaymentJc },
  props: {
    visible: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      detailDialog: {
        visible: false,
        mergeType: false,
        title: '',
        uuids: [],
        action: 'add'
      },
      innerVisible: false,
      fullscreenLoading: null
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  created() {
    if (this.visible) {
      this.innerVisible = true
    }
  },
  methods: {
    // 合并生成
    mergeGeneratePay() {
      this.doGenerate(true)
    },
    // 生成应付单
    generatePay() {
      this.doGenerate(false)
    },
    doGenerate(mergeType) {
      const list = this.$refs.bpPage.selectedData()
      if (!list || list.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectPaymentApplication'))
        return
      }
      let invoiceTitle = ''
      for (const data of list) {
        if (!invoiceTitle) {
          invoiceTitle = data.billPaymentInvoiceTitle
        } else if (invoiceTitle !== data.billPaymentInvoiceTitle) {
          this.$message.warning(this.$t('CargoMsg.Cargo_SelectAp2'))
          return
        }
      }
      this.detailDialog.visible = true
      this.detailDialog.mergeType = mergeType
      this.detailDialog.uuids = Array.from(list, p => p.uuid)
      this.detailDialog.title = this.$t('CargoMsg.Cargo_PayableSingleAttribute')
    },
    saveHandler() {
      this.innerVisible = false
      this.$emit('saveResult')
    },
    onCancel() {
      this.$emit('close')
    }
  }
}
</script>

<style scoped>

</style>
